import React, { useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { PREVIEW_PLANS, FREE_AND_PREVIEW_PLANS } from '../constants/constants';
import { TOPBAR_VIEW_PLANS } from '../constants/hotjar-events';
import { useOrganisation, useOrganisationUsage } from '../http-hooks/organisation/useOrganisation';

function TopBanner({ inline }) {

    const { org_id } = useParams();
    const history = useHistory();

    // Use the shared live balance (same query the feature/TTS flows invalidate on completion),
    // rather than a one-off /organisation fetch of legacy fields that never refreshed.
    const { data: org } = useOrganisation({ org_id });
    const { data: usage } = useOrganisationUsage({ org_id });

    const Nudge = ({ message, dismissable }) => {

        const [dismissed, setDismissed] = useState(false);

        const closeTopBanner = () => {
            setDismissed(true)
        }

        return (
            <div className={`position-relative  pt-5 pt-md-1 pb-2 pb-md-1 px-2 justify-content-center my-2 ${dismissed ? 'd-none' : 'd-flex'}`} style={{ backgroundColor: 'var(--bs-primary)', color: 'white', borderRadius: (inline) ? '3px' : '0px' }}>
                <span>{message}</span>
                {/* <span 
                    className="ms-3 text-decoration-none" 
                    style={{color:'var(--bs-warning)', borderBottom: 'dotted 2px var(--bs-warning)', cursor: 'pointer'}} 
                    onClick={() => {
                        window.hj("event", TOPBAR_VIEW_PLANS);
                        history.push(`/organisation/${org_id}/upgrade`)
                    }}
                >
                    View Plans
                </span> */}
                {
                    dismissable && (
                        <svg onClick={closeTopBanner} role="button" className='position-absolute' style={{ right: '10px', top: '10px' }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13M1 13L13 1L1 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )
                }

            </div>
        )

    }

    // return <Nudge message="Some of our voices are facing issues. Choose a different voice if you cannot generate audio." dismissable />

    if (!org || !usage) {
        return <></>
    }

    // if ([...PREVIEW_PLANS].includes(org.plan_id))
    //     return (
    //         <Nudge message="Upgrade your plan to unlock all features" dismissable  />
    //     )

    // Percentage of the credit balance consumed, derived from the live usage endpoint.
    // Fall back to legacy words_* fields so this works whether or not the API has the credits_* rename.
    const creditsLimit = usage.plan_credits_limit ?? usage.plan_words_limit ?? 0;
    const creditsRemaining = usage.credits_remaining ?? usage.words_remaining ?? 0;
    const creditsUsagePercent = creditsLimit > 0
        ? Math.round(((creditsLimit - creditsRemaining) / creditsLimit) * 100)
        : 0;

    if (creditsUsagePercent >= 100) {
        return (
            <Nudge message="You have reached your credit limit. To continue using Listen2It seamlessly, please upgrade your account." />
        )
    }

    if (creditsUsagePercent >= 85) {
        return <Nudge message="You have reached 85% of your credit limit. To continue using Listen2It, please upgrade your account." dismissable={true} />
    }

    // if(["free-plan", "free-plan-inr"].includes(org.plan_id)){
    //     return (
    //         <Nudge message="Get a 14 day free trial with our paid plans. Cancel Anytime." dismissable={true} />
    //     )
    // }

    return (
        <></>
    )

}

export default TopBanner;
